import * as h from '../helpers/helpers';
import * as scf from './salesComparisonFunctions';

export function DepreciatedCost(type) {
	let list = [];
	// for each dwelling
	// get relationships
	// each section: Depreciated Cost - [dwelling identifier]
	const iLabels = global.ptr.subImprovs.GetImprovementLabels();

	for (const improvementLabel of iLabels) {
		const improv = global.ptr.subImprovs.GetImprovementByLabel(improvementLabel);
		if (!improv) continue;
		if (improv.improvementDetail.improvementType !== type) continue;

		list.push(improv);
		// let row0 = GetDepreciatedCostDwelling(improv);
		// console.log(row0);
	}
	return list;
}

export function GetDepreciatedCost(improv) {
		let row0 = [];
		let total = 0;

		const rels = global.ptr.relationships.GetRelationshipsTo("IMPROVEMENT_COST_AND_DEPRECIATED_VALUE_IsAssociatedWith_IMPROVEMENT", improv.label);
		if (rels.length === 0) return row0;
		const icdvLabel = rels[0];

		// get the improvement cost and indicated value for the indicated dwelling
		const icdv = global.ptr.approachToValue.costApproach.GetImprovementCostAndDepreciatedValue(icdvLabel);
		const rrcs = icdv.GetReplacementCosts();

		for (const rrc of rrcs) {
			const rrcAmount = rrc.replacementOrReproductionCostAmount.Value || 0;
			total += rrcAmount;
			const area = rrc.GetCostAreaType();
			const measure = rrc.replacementOrReproductionCostAreaMeasure;
			const areaSize = measure.ToString() + " @ " + h.toDollarAndCentsAmount(rrc.pricePerAreaAmount.Value);
			// const areaMeasure = measure.Value;
			// const costAmount = rrc.pricePerAreaAmount || 0;
			const areaCost = h.toDollarString(rrcAmount);

			let row1 = [];
			row1.push(area);
			row1.push("^"+areaSize);
			row1.push(">"+areaCost);
			row0.push(row1);
		}


		const depCost = -icdv.improvementDepreciation.depreciationTotalAmount.Value;
		total += depCost;
		let row1 = [];
		row1.push("Total Depreciation");
		row1.push("");
		row1.push(">"+h.toDollarAmount(depCost));
		row0.push(row1);

		const methods = improv.structure.GetConstructionMethods();
		if (methods.includes("Manufactured")) {
			const setup = icdv.improvementCost.improvementCostDetail.manufacturedHomeInstallationCostAmount.Value || 0;
			total += setup;
			let row1 = [];
			row1.push("Manufactured Home Delivery,\nInstallation, and Set Up");
			row1.push("");
			row1.push(">"+h.toDollarString(setup));
			row0.push(row1);
		}

	global.ptr.tempTotal = total;
	return row0;
}

export function CostAsIsValues() {
	let list = [];
	if (!global.ptr.costApproach) return list;

	for (let asis of global.ptr.costApproach.siteImprovementsAsIsCosts) {
		let row1 = [];
			row1.push(asis.siteImprovementDescription);
			row1.push(asis.siteImprovementAsIsCostAmount.ToDollarAmount());
		list.push(row1);
	}

	return list;
}

export function GetCostDataSource() {
	let dsSrc = "";

	let crels = global.ptr.relationships.GetRelationshipsTo("DATA_SOURCE_IsDataSourceFor_COST_APPROACH", global.ptr.costApproach.label);
	let ds = global.ptr.dataSources.GetDataSourceClass(crels);
	if (ds)	{
		let dsType = ds.GetSourceType();
		dsSrc = (ds.dataSourceType === "CostService") ? h.toEnumText(ds.dataSourceName) : dsType;
	}

	return dsSrc;
}

export function GetCostDataSourceQualityRating() {
	let crels = global.ptr.relationships.GetRelationshipsTo("DATA_SOURCE_IsDataSourceFor_COST_APPROACH", global.ptr.costApproach.label);
	let ds = global.ptr.dataSources.GetDataSourceClass(crels);
	let dsQR = h.toEnumText(ds.dataSourceQualityRatingCode);
	return dsQR;
}

export function GetCostDataSourceEffectiveDate() {
	let crels = global.ptr.relationships.GetRelationshipsTo("DATA_SOURCE_IsDataSourceFor_COST_APPROACH", global.ptr.costApproach.label);
	let ds = global.ptr.dataSources.GetDataSourceClass(crels);
	let dsED = ds.dataSourceEffectiveDate.FormatMDY();
	return dsED;
}

